import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ProtectedRoutes, ProtectedRoutesLogin } from "../navigations/Autorizador"
import ErrorPage from "../page/errorPage/ErrorPage"
import DashboardHome from "../page/dashboardHome/DashboardHome"
import HistorialPage from "../page/historial/HistorialPage"
import MisDatosPage from "../page/misDatos/MisDatosPage"
import LoginPage from "../page/login/LoginPage"
import DetailsPage from "../page/historial/DetailsPage"
import PaymentPage from "../page/dashboardHome/paymentAlias/PaymentPage"
import ConfirmacionPage from "../page/dashboardHome/confirmacion/ConfirmacionPage"
import PaymentVerificacionPage from "../page/dashboardHome/paymentAlias/PaymentVerificacionPage"
import SeguridadPage from "../page/seguridad/SeguridadPage"
import SplashIcon from "../splash/SplashIcon"
import Terminos from "../components/constantes/Terminos"
import SettingPage from "../page/settings/SettingPage"


function RutesScreen() {

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoutesLogin />} >
          <Route path="/" element={<SplashIcon />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/terminosycondiciones" element={<Terminos />} />
        </Route>

        {/* <Route element={<ProtectedRoutes />}> */}
        <Route path="/home" element={<DashboardHome />} />
        <Route path="/home/payment" element={<PaymentPage />} />
        <Route path="/home/payment/verificacion" element={<PaymentVerificacionPage />} />
        <Route path="/home/payment/confirmacion" element={<ConfirmacionPage />} />
        <Route path="/historial" element={<HistorialPage />} />
        <Route path="/historial/informacion" element={<DetailsPage />} />
        <Route path="/perfil" element={<MisDatosPage />} />
        <Route path="/seguridad" element={<SeguridadPage />} />
        {/* <Route path="/settings" element={<SettingPage />} /> */}
        <Route path="*" element={<ErrorPage />} />
        {/* </Route> */}

      </Routes>
    </BrowserRouter>
  )
}

export default RutesScreen